import type { SVGProps } from "react";

const IconDoubleArrow = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_136)">
        <path
          d="M11.9739 1.22174C12.0972 1.0863 12.2644 1.01319 12.4343 1.00499C12.6045 0.997114 12.7776 1.05417 12.9134 1.17747C13.0488 1.30111 13.1219 1.46836 13.1301 1.63824C13.138 1.8081 13.0809 1.9816 12.9577 2.11702L7.4582 7.5768C7.33523 7.71028 7.16961 7.78176 7.00104 7.78964C6.83115 7.79785 6.65804 7.74111 6.52226 7.61746L6.51898 7.61451L6.51866 7.61451L6.51866 7.61418L6.50092 7.5975L6.49767 7.59389L6.48061 7.57614L6.48061 7.57647L6.47931 7.57519L6.4757 7.57089L6.47343 7.56862L0.981806 2.11703C0.858171 1.9816 0.801447 1.80812 0.809336 1.63826C0.817525 1.46837 0.890342 1.30112 1.02608 1.17749C1.16154 1.05419 1.33502 0.997127 1.50488 1.00502C1.67475 1.0132 1.842 1.08634 1.96563 1.22177L6.96958 6.1385L11.9739 1.22177L11.9739 1.22174Z"
          fill="#667D98"
        />
        <path
          d="M11.9739 6.49715C12.0972 6.36142 12.2644 6.28861 12.4343 6.28038C12.6045 6.27251 12.7776 6.32925 12.9134 6.45288C13.0488 6.57617 13.1219 6.74344 13.1301 6.91364C13.138 7.0835 13.0809 7.25665 12.9577 7.39241L7.4582 12.8519C7.33523 12.9854 7.1696 13.0572 7.00104 13.065C6.83115 13.0729 6.65804 13.0165 6.52226 12.8929L6.51898 12.8899L6.51865 12.8896L6.50092 12.8725L6.49767 12.8693L6.4806 12.8515L6.4806 12.8519L6.47931 12.8506L6.47568 12.8463L6.47341 12.8437L0.981791 7.39242C0.858156 7.25669 0.801432 7.08351 0.80932 6.91365C0.817511 6.74343 0.890326 6.5762 1.02606 6.45289C1.16152 6.32927 1.335 6.27253 1.50486 6.2804C1.67472 6.28861 1.84198 6.36142 1.96562 6.49716L6.96957 11.4136L11.9739 6.49716L11.9739 6.49715Z"
          fill="#667D98"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_136">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(14) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconDoubleArrow;
